import classNames from "classnames";
import Link from "next/link";
import { ShopMatchCard } from "@components/ShopMatchCard";
import type { ShopMatchCard_ShopMatchFragment } from "@components/ShopMatchCard/__generated__/fragments";
import { paths } from "@libs/paths";
import styles from "./index.module.css";
import type { FC } from "react";

type Props = {
  shopUuid: string;
  shopName: string;
  shopTel: string;
  shopTelWithHyphen: string;
  shopMatches: ShopMatchCard_ShopMatchFragment[];
};

const BroadcastList: FC<Props> = ({
  shopUuid,
  shopName,
  shopTel,
  shopTelWithHyphen,
  shopMatches,
}) => {
  return (
    <section className={styles.broadcastSchedule}>
      <div className={classNames(styles.columnInner, "l-main__innerWidth")}>
        <div className={styles.top}>
          <h1 className={`${styles.contentTitle} c-contentTitle`}>上映予定</h1>
          {shopMatches.length > 0 && (
            <Link href={paths.shopMatches(shopUuid)} className={styles.all}>
              すべてを見る
            </Link>
          )}
        </div>
        {shopMatches.length > 0 ? (
          <div className={styles.matchList}>
            {shopMatches.map((sm) => (
              <ShopMatchCard
                key={sm.id}
                shopMatch={sm}
                shopUuid={shopUuid}
                shopName={shopName}
                shopTel={shopTel}
                shopTelWithHyphen={shopTelWithHyphen}
              />
            ))}
          </div>
        ) : (
          <p className={styles.lead}>上映予定の試合はありません</p>
        )}
      </div>
    </section>
  );
};

export default BroadcastList;
